import { gql } from '@apollo/client';

export const ADDRESS_DELETE = gql`
    mutation deleteAddress( $id: UUID! ) {
        deleteAddress( id: $id ){
            success
            message
        }
    }
`;

export default ADDRESS_DELETE;
